/**
 * Registers DataTables on the same jQuery instance the app uses.
 * Must load before any lazy chunk calls $(...).DataTable(...) (e.g. FileTable on /case).
 */
import $ from 'jquery';

window.jQuery = window.jQuery || $;
window.$ = window.$ || $;

require('datatables');
require('datatables.net-bs');
